<section id="sticky-header">
    <div class="wrapper">
        <div *ngIf="submitted && maintenanceForm.errors?.invalid" class="alert alert-danger alert-dismissible fade show server-error" #errorMessageDiv>
            <strong>Error!</strong> {{maintenanceForm.errors?.invalid}}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
        <div *ngIf="submitted && isSaved && maintenanceForm.valid" class="alert alert-success alert-dismissible fade show server-error" #successMessageDiv>
            <strong>Success!</strong> {{isEdit ? 'Updated Successfully!.' : 'Saved Successfully!.'}}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
    </div>
</section>

<section class="wrapper edit-page">
    <div class="tracker-info-form">
        <h4 class="form-title">Model Maintenance</h4>
        <div class="responsive-grid">
            <form [formGroup]="maintenanceForm">
                <div class="grid-row clearfix">
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            CUSTOMER
                        </label>
                        <div class="relative">
                            <input type="text" [ngClass]="{'disabled': isEdit || isView}" [readonly]="isEdit || isView" class="form-control" formControlName="customer" placeholder="">
                        </div>
                        <div *ngIf="submitted && maintenanceForm.controls.customer.errors" class="invalid-feedback">
                            <div *ngIf="maintenanceForm.controls.customer.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            STATE
                        </label>
                        <div class="relative">
                            <input type="text" [ngClass]="{'disabled': isEdit || isView}" [readonly]="isEdit || isView" class="form-control" formControlName="state" placeholder="">
                        </div>
                        <div *ngIf="submitted && maintenanceForm.controls.state.errors" class="invalid-feedback">
                            <div *ngIf="maintenanceForm.controls.state.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            Start Date
                        </label>
                        <div>
                            <input type="date" class="form-control" [ngClass]="{'disabled': isView}" [readonly]="isView" [min]="todayDate" formControlName="startdate" placeholder="">
                        </div>
                        <div *ngIf="submitted && maintenanceForm.controls.startdate.errors" class="invalid-feedback">
                            <div *ngIf="maintenanceForm.controls.startdate.errors.required">Please select start date</div>
                            <div *ngIf="maintenanceForm.controls.startdate.errors.inValidStartDate">Start date must be equal to or greated than today's date</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            End Date
                        </label>
                        <div>
                            <input type="date" class="form-control" [ngClass]="{'disabled': isView}" [readonly]="isView" formControlName="enddate" placeholder="">
                        </div>
                        <div *ngIf="submitted && maintenanceForm.controls.enddate.errors" class="invalid-feedback">
                            <div *ngIf="maintenanceForm.controls.enddate.errors.required">Please select end date</div>
                            <div *ngIf="maintenanceForm.controls.enddate.errors.endDateMismatch">End Date Should be Equal to or Greater than Start Date</div>
                        </div>

                    </div>
                </div>
                <div class="grid-row clearfix">
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            STORE/MODEL
                        </label>
                        <div class="relative">
                            <input type="text" [ngClass]="{'disabled': isEdit || isView}" [readonly]="isEdit || isView" class="form-control" formControlName="store" placeholder="">
                        </div>
                        <div *ngIf="submitted && maintenanceForm.controls.store.errors" class="invalid-feedback">
                            <div *ngIf="maintenanceForm.controls.store.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            LOT NBR
                        </label>
                        <div>
                            <input type="text" [ngClass]="{'disabled': isEdit || isView}" [readonly]="isEdit || isView" class="form-control" formControlName="lot" placeholder="" oninput="this.value = this.value.toUpperCase()">
                        </div>
                        <div *ngIf="submitted && maintenanceForm.controls.lot.errors" class="invalid-feedback">
                            <div *ngIf="maintenanceForm.controls.lot.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            CONSIGN TYPE
                        </label>
                        
                        <div class="relative" *ngIf="!isView && !isCopy && !isEdit">
                            <select formControlName="consignType" class="form-control">
                                <option *ngFor="let type of consignTypes" [ngValue]="type.value">{{type.name}}</option>
                            </select>
                        </div>
                        <div *ngIf="isView || isCopy || isEdit">
                            <input type="text" [ngClass]="{'disabled': isView || isCopy || isEdit}" [readonly]="isView" class="form-control" formControlName="consignType" placeholder="">
                        </div>
                    </div>
                </div>
                <div class="grid-row clearfix" *ngIf="isCopy || modelCustomerData?.modelCustomer">
                    <div class="col-25">
                        <label for="" class="field-label">
                            COPY Customer
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" [ngClass]="{'disabled': true}" [readonly]="true" formControlName="modelCustomer" placeholder="">
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            COPY STATE
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" [ngClass]="{'disabled': true}" [readonly]="true" formControlName="modelState" placeholder="">
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            COPY STORE/MODEL
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" [ngClass]="{'disabled': true}" [readonly]="true" formControlName="modelStore" placeholder="">
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            COPY LOT NBR
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" [ngClass]="{'disabled': true}" [readonly]="true" formControlName="modelLot" placeholder="">
                        </div>
                    </div>
                    
                </div>
                <div class="tracker-info-form">
                    <ng-container formArrayName="orderModelDetail">
                        <ng-container *ngFor="let size of orderModelDetail.controls; let i=index">
                            <div [formGroupName]="i" class="grid-row clearfix">
                                <div class="col-25">
                                    <label for="" class="field-label">
                                        DIM1
                                    </label>
                                    <div class="relative">
                                        <input type="text" class="form-control" [ngClass]="{'disabled': isDisabledField(i)}" [readonly]="isDisabledField(i)" formControlName="dim1" placeholder="" oninput="this.value = this.value.toUpperCase()">
                                    </div>
                                    <div class="invalid-feedback">
                                        <div *ngIf="checkSizeDetailsErrors('dim1', 'required', i)">This is required</div>
                                        <div *ngIf="checkSizeDetailsErrors('dim1', 'duplicateName', i)">Duplicate size on model</div>
                                    </div>
                                </div>
                                <div class="col-25">
                                    <label for="" class="field-label">
                                        DIM2
                                    </label>
                                    <div class="relative">
                                        <input type="text" class="form-control" [ngClass]="{'disabled': isDisabledField(i)}" [readonly]="isDisabledField(i)" formControlName="dim2" placeholder="" oninput="this.value = this.value.toUpperCase()">
                                    </div>
                                    <div class="invalid-feedback">
                                        <div *ngIf="checkSizeDetailsErrors('dim2', 'required', i)">This is required</div>
                                    </div>
                                </div>
                                <div class="col-20">
                                    <label for="" class="field-label">
                                        QTY
                                    </label>
                                    <div class="relative">
                                        <input type="text" class="form-control" [ngClass]="{'disabled': isDisabledField(i)}" [readonly]="isDisabledField(i)" formControlName="qty" placeholder="">
                                    </div>
                                    <div class="invalid-feedback">
                                        <div *ngIf="checkSizeDetailsErrors('qty', 'required', i)">This is required</div>
                                        <div *ngIf="checkSizeDetailsErrors('qty', 'pattern', i)">Model quantity must be numeric</div>
                                    </div>
                                </div>
                                <div class="col-20" *ngIf="isEdit || isView">
                                    <label for="" class="field-label">
                                        NEW QTY
                                    </label>
                                    <div class="relative">
                                        <input type="text" class="form-control" [ngClass]="{'disabled': isView}" [readonly]="isView" formControlName="newQty" placeholder="">
                                    </div>
                                    <div class="invalid-feedback">
                                        <div *ngIf="checkSizeDetailsErrors('newQty', 'pattern', i)">Model quantity must be numeric</div>
                                    </div>
                                </div>
                                <div class="col-5" *ngIf="i != 0 && !isView && !isEdit || (isEdit && !isExistingField(i))">
                                    <div class="delete-icon" (click)="deleteSizeDetails(i)"></div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <button type="button" (click)="addSizeDetails()" *ngIf="!isView" class="add-more">ADD MORE +</button>
                </div>
            </form>
        </div>
    </div>

    <div class="mt-25 align-right pb-20 mb-20">
        <button class="btn btn-secondary ml-10" (click)="cancelPage()">Cancel</button>
        <button class="btn btn-primary ml-10" *ngIf="!isEdit && !isView" (click)="addModelData()">Add</button>
        <button class="btn btn-primary ml-10" *ngIf="isEdit && !isView" (click)="addModelData()">Update</button>
    </div>

</section>